import { BlockLayout } from "@redotech/redo-web/flowchart";
import FlipBackwardIcon from "@redotech/redo-web/icon-old/flip-backward.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepId, StepType, StepTypeDetailsProps } from "./step";

export interface StartState {
  next: StepId | undefined;
}

export function getStartStep(
  firstStepTitle: string,
  Details: React.ComponentType<StepTypeDetailsProps<StartState>>,
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>,
): StepType<StartState, any> {
  const IconComponent = Icon || FlipBackwardIcon;
  return {
    description() {
      return "";
    },
    Details: (props: StepTypeDetailsProps<StartState>) =>
      React.createElement(Details, props),
    customTitle() {
      return undefined;
    },
    empty: { next: undefined },
    start(state) {
      return state.next;
    },
    ignore: true,
    Icon: (props: { className?: string }) =>
      React.createElement(IconComponent, props),
    title: firstStepTitle,
    valid: (state) => state.next !== undefined,
    stepDeleted(state, stepId) {
      return produce(state, (state) => {
        if (state.next === stepId) {
          state.next = undefined;
        }
      });
    },
    layout() {
      return BlockLayout.COMPACT;
    },
    fromModel() {
      throw new Error("Unsupported");
    },
    toModel() {
      throw new Error("Unsupported");
    },
    downstream(state) {
      const result: StepDownstream[] = [];
      if (state.next) {
        result.push({ id: state.next });
      }
      return result;
    },
    maxDownstream() {
      return 1;
    },
    updateConnection(state, handleIndex, targetStepId) {
      if (handleIndex !== 0) {
        throw new Error(`Invalid handle index ${handleIndex} for Start step`);
      }
      return produce(state, (draft) => {
        draft.next = targetStepId;
      });
    },
    removeConnection(state, targetStepId) {
      return produce(state, (draft) => {
        if (draft.next === targetStepId) {
          draft.next = undefined;
        }
      });
    },
  };
}
